import {all, call, fork, put, takeEvery} from 'bukku/shared/SagaService';
import {message} from 'antd';
import actions from './actions';
import AppActions from '../App/actions';
// import {t} from "@lingui/macro";
import {post} from 'bukku/shared/ApiService';
import {prepareBatchRequestData} from "./helpers/prepareBatchRequestData";
import {getTransactionType} from "./helpers/getTransactionType";
// import {getTransactionText} from "./helpers/getTransactionText";
import {getServerUrl} from "../Transaction/helpers/getServerUrl";

// Batch Create (Import)
export function* createRequest() {
    yield takeEvery(actions.BATCH_INVOICING_CREATE_REQUEST, function* (props, context) {
        try {
            yield put({ type: AppActions.APP_START_PUSHING });

            const { tableName, period_lock_passcode, credit_limit_passcode } = props;

            // Prepare Request Data
            const request = yield prepareBatchRequestData(tableName);
            const transactionType = getTransactionType(tableName);

            // after interceptor onOk - for period lock
            if (period_lock_passcode)
                request.period_lock_passcode = period_lock_passcode;

            // after interceptor onOk - for credit limit
            if (credit_limit_passcode)
                request.credit_limit_passcode = credit_limit_passcode;

            context.allow_intercept = true;

            // Sending to Server
            const response = yield call(post, `${getServerUrl(transactionType)}/import`, request, context);
            const data = yield response.data;

            // OK
            yield put({
                type: actions.BATCH_INVOICING_CREATE_SUCCESS,
                tableName,
                data,
            });
            // To be done in BatchInvoicingPage.js
            // yield message.success(t`${data.count} ${getTransactionText(tableName)} are created.`);
        }
        catch (error) {
            console.log('aaa BATCH_INVOICING_CREATE_ERROR', error);
            yield put({
                type: actions.BATCH_INVOICING_CREATE_ERROR,
                error,
                // request,
            });
        }
        finally {
            yield put({ type: AppActions.APP_STOP_PUSHING });
        }
    });
}

export function* createError() {
    yield takeEvery(actions.BATCH_INVOICING_CREATE_ERROR, function* ({error}) {
        console.log('aaa BATCH_INVOICING_CREATE_ERROR', error);
        if (!error.canSuppress)
            yield message.error(error.message);
    });
}

export default function* rootSaga() {
    yield all([
        fork(createRequest),
        fork(createError),
    ]);
}
